import { CircularProgress } from "@mui/material";
import React from "react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import useAuth from "./app/useAuth";
import { createAuthRouter, createUnAuthRouter } from "./route/route";

export default function App() {
  const { isLoggedIn, l, loading } = useAuth();

  // Router, oturum durumu netleştikten sonra o anki URL için oluşturulur.
  // Oturum değiştiğinde (login/logout/süre dolumu) yeni router kurulur; böylece
  // /login'de kalma, bayat loader hatası gibi sorunlar oluşmaz.
  const prevLoggedIn = React.useRef<boolean | null>(null);
  const router = React.useMemo(() => {
    const sessionEnded = prevLoggedIn.current === true && !isLoggedIn;
    prevLoggedIn.current = isLoggedIn;
    return isLoggedIn
      ? createAuthRouter()
      : createUnAuthRouter({ sessionEnded });
  }, [isLoggedIn]);

  // Önceki router'ı kapat: bekleyen navigasyonu iptal eder, URL'yi sonradan
  // değiştirmesini engeller (StrictMode'a dayanıklı: yalnızca farklı router).
  const activeRouter = React.useRef(router);
  React.useEffect(() => {
    if (activeRouter.current !== router) {
      activeRouter.current.dispose();
      activeRouter.current = router;
    }
  }, [router]);

  if (loading || l) return <CircularProgress />;
  // key: RouterProvider, router prop'u değişince iç state'ini sıfırlamaz;
  // oturum değişiminde provider'ı baştan mount etmek gerekir.
  return (
    <RouterProvider key={isLoggedIn ? "auth" : "unauth"} router={router} />
  );
}
